export { GlobalErrorHandler } from './GlobalErrorHandler';



// WEBPACK FOOTER //
// ./app/common/components/GlobalErrorHandler/index.ts